<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card :title="cardTitle" write-toggler @writeClick="popupOpen('', '')">
            <div class="vx-row">
                <div class="vx-col w-full xl:w-1/1 mb-base text-center">
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="prevMonth"></vs-button>
                    <span class="ml-5 mr-5"
                        >{{ start_date.substring(0, 4) + '-' + start_date.substring(4, 6) + '-' + start_date.substring(6, 8) }} ~
                        {{ end_date.substring(0, 4) + '-' + end_date.substring(4, 6) + '-' + end_date.substring(6, 8) }}</span
                    >
                  <date-picker
                      id="datepicker-component"
                      v-model="now_date"
                      @change="updateDate"
                      type="week"
                      :lang="{formatLocale: {firstDayOfWeek: 1}}"
                      value-type="format"
                      format="YYYYMMDD"
                  >
                  </date-picker>
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="nextMonth"></vs-button>

                    <!-- 날짜 범위 필터 (2025-02-24) -->
                    <DayFilterButtons
                        :value="dayFilter"
                        @change="changeDayFilter"
                    />
                </div>
            </div>
            <vs-button type="line" v-bind:class="activeMenu('')" v-on:click="tabClick('')" v-show="tab_all_tf">전체</vs-button>
            <vs-button type="line" v-for="(item, index) in tab_menu" :key="index" v-bind:class="activeMenu(item.MEDICAL_CD)" v-on:click="tabClick(item.MEDICAL_CD)">{{ item.MEDICAL_NM }}</vs-button>
            <br /><br />
            <div>
                <span>* 해당 날짜에 시간 셀을 클릭하시면 환자를 등록할 수 있습니다.</span>
            </div>
            <!-- <div class="text-right">
                <a :href="'/api/injection/excel/' + now_date + '?medical_cd=' + medical_cd" download="download"><vs-button size="small">엑셀다운로드</vs-button></a>
            </div> -->
            <div class="flex justify-end flex-wrap mb-3">
                <vs-button radius color="primary" icon-pack="feather" icon="icon-edit-2" @click="popupOpen('', '')" />
                <!-- <a :href="'/api/doctor/excel/' + now_date + '?medical_cd=' + medical_cd" download="download"><vs-button size="small">엑셀다운로드</vs-button></a> -->
                <vx-tooltip text="엑셀 다운로드" position="top" class="ml-3">
                    <a :href="'/api/injection/excel/' + now_date + '?medical_cd=' + medical_cd" download="download">
                        <vs-button radius color="primary" icon-pack="feather" icon="icon-download" />
                    </a>
                </vx-tooltip>
            </div>
            <div class="tb_wrap">
                <div class="tb_box" id="calendarDiv" style="width:100%;overflow-x:auto; height:900px;">
                    <table id="schedule" style="max-width:1200px; max-height:550px;" class="border-collapse calendar">
                        <thead>
                            <tr class="fixed_top">
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:100px !important;">시간 / 일</th>
                                <th
                                    class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    :style="item.substring(6, 8) == now_day ? 'background-color:#439798 !important; color:#fff;z-index:999;' : 'z-index:999;'"
                                    v-for="(item, index) in date_list"
                                    :key="index"
                                    v-bind:id="item"
                                >
                                    <div style="padding-bottom:5px;">
                                        <b style="font-size:12px;">{{ dayReturn(item) }}</b>
                                    </div>
                                    <div>
                                        <span v-for="(item2, index2) in (cure_count[index] || {}).JSON_DATA" :key="index2" style="margin-top:10px;">
                                            <template v-if="(cure_count[index] || {}).JSON_DATA[index2 + 1] == undefined"> {{ item2.MEDICAL_NM }}({{ item2.CNT }}) </template>
                                            <template v-else> {{ item2.MEDICAL_NM }}({{ item2.CNT }}) / </template>
                                        </span>
                                    </div>
                                </th>
                            </tr>
                            <!-- 연차 행 -->
                            <VacationRow
                                v-if="vacationMap.size > 0"
                                :date-list="date_list"
                                :vacation-map="vacationMap"
                                :date-key-format="formatDateKeyForVacation"
                                :sticky="true"
                                sticky-top="40px"
                                :show-full-name="true"
                            />
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in cure_data" :key="index">
                                <th class="border border-solid d-theme-border-grey-light text-center table_header b-table-sticky-column timeHeader" style="" :id="item.CODE_TIME.substring(0, 2)">
                                    <!-- <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="" :id="item.CODE_TIME.substring(0, 2)"> -->
                                    <span> {{ item.CODE_TIME.substring(0, 2) }}</span>
                                </th>
                                <td
                                    class="border border-solid d-theme-border-grey-light"
                                    style="min-width:700px;height:100px;vertical-align:top;padding:0px;"
                                    v-for="(day, schedule_index) in date_list"
                                    :key="schedule_index"
                                >
                                    <table class="contentTable" width="100%" cellspacing="0">
                                        <colgroup>
                                            <col width="50" />
                                            <col width="80" />
                                            <col width="30" />
                                            <col width="100" />

                                            <col width="*" />
                                            <col width="100" />
                                            <col width="100" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th class="text-center headerBtn" colspan="7">
                                                    <vs-row vs-type="flex" vs-justify="center">
                                                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                                                            <a href="javascript:void(0)" @click="popupOpen(day, item.CODE_TIME)">
                                                                <i class="vs-icon notranslate icon-scale feather icon-edit-2 null" style="order: 0; margin-right: 0px; margin-left: 0px;"></i>
                                                            </a>

                                                            <a href="javascript:void(0)" @click="clipCopyConfirm(day, item.CODE_TIME)">
                                                                <i class="vs-icon notranslate icon-scale feather icon-copy null" style="order: 0; margin-right: 0px; margin-left: 0px;"></i>
                                                            </a>
                                                            <a href="javascript:void(0)" @click="openMultiCopyModal(day, item.CODE_TIME)" title="다중복사">
                                                                <i class="vs-icon notranslate icon-scale feather icon-layers null" style="order: 0; margin-right: 0px; margin-left: 0px; color: #28a745;"></i>
                                                            </a>
                                                        </vs-col>
                                                    </vs-row>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item_data, item_index) in item.schedules_by_day[day]" :key="item_index" :style="getBtnColor(item_data)">
                                                <td>
                                                    <!-- {{ item_data }} -->
                                                    <input type="checkbox" v-model="copyChecked" :value="item_data.SCHEDULE_SEQ" />
                                                </td>
                                                <td>{{ (item_data.REAL_TIME_STRING || '').substring(0, 2) }}:{{ (item_data.REAL_TIME_STRING || '').substring(2, 4) }}</td>
                                                <td>[{{ (item_data.MEDICAL_NM || '').substring(0, 1) }}]</td>
                                                <td>
                                                    <a :href="'/patientSchedule/scheduleCalendar/' + item_data.PATIENT_UID">
                                                        <template v-if="item_data.DC == 'Y'">
                                                            <span style="text-decoration:line-through">{{ (!item_data.STATUS_NAME || item_data.STATUS_NAME === '외래') ? '외래' : item_data.MEDICAL_ROOM_NUMBER_NM }} {{ item_data.PATIENT_USERNAME }}</span>
                                                        </template>
                                                        <template v-else>{{ (!item_data.STATUS_NAME || item_data.STATUS_NAME === '외래') ? '외래' : item_data.MEDICAL_ROOM_NUMBER_NM }} {{ item_data.PATIENT_USERNAME }}</template>
                                                    </a>
                                                </td>
                                                <td>
                                                    <template v-if="item_data.DC == 'Y'">
                                                        <span>{{ item_data.DC_MEMO }}</span>
                                                    </template>
                                                    <template v-else>
                                                        <span>{{ getManagerNamesSimple(item_data) }}</span>
                                                        / {{ getDetailNames(item_data) }} / {{ item_data.MEMO }}
                                                    </template>
                                                </td>
                                                <td>{{ (item_data.MEDICAL_MEMBER_USERNAME || '').substring(0, 1) }} / {{ (item_data.WEST_MEDICAL_USERNAME || '').substring(0, 1) }}</td>
                                                <td>
                                                    <a href="#" @click="memberView(item_data.PATIENT_UID)">
                                                        <i class="vs-icon notranslate icon-scale  feather icon-search null" style="order: 0; margin-right: 0px; margin-left: 0px; color:#31C872;"></i>
                                                    </a>
                                                    &nbsp;
                                                    <a href="#" @click="popupmodify(item_data)">
                                                        <i class="vs-icon notranslate icon-scale feather icon-edit-2 null" style="order: 0; margin-right: 0px; margin-left: 0px;color:#015666;"></i>
                                                    </a>
                                                    &nbsp;
                                                    <a href="javascript:void(0)" @click="calendarTdDelete(item_data)">
                                                        <i class="vs-icon notranslate icon-scale  feather icon-x null" style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- Infinite scroll sentinel -->
                    <div
                        v-if="hasMoreTimeSlots"
                        ref="scrollSentinel"
                        style="height:40px; display:flex; justify-content:center; align-items:center;"
                    >
                        <span v-if="isLoadingMore">로딩 중...</span>
                    </div>
                </div>
            </div>
        </vx-card>
        <vs-popup title="스케줄 등록" :active.sync="popupActive">
            <form @submit.prevent>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1">
                        <!-- <vs-select class="w-auto" autocomplete v-model="select_medical_cd" label="치료실" placeholder="스케줄 옵션">
                            <vs-select-item v-for="(item, index) in tab_menu" :key="`medical-${index}`" :value="item.MEDICAL_CD" :text="item.MEDICAL_NM" />
                        </vs-select> -->

                        <v-select :maxHeight="'50px'" @input="select_medical_input" v-model="select_medical_cd" :options="tab_options" :dir="$vs.rtl ? 'rtl' : 'ltr'"> </v-select>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/2 ">
                        <label for="" class="vs-select--label">날짜</label>
                        <datepicker name="uniquename" v-model="select_date" placeholder="날짜선택" :format="customFormatter"></datepicker>
                    </div>
                    <div class="vx-col w-full lg:w-1/2">
                        <!-- <vs-select class="w-auto" v-model="select_time" autocomplete label="시간" placeholder="시간">
                            <vs-select-item v-for="(item, index) in time_list" :key="`time-${index}`" :value="item.CODE_TIME" :text="item.TIME_NAME" />
                        </vs-select> -->

                        <label for="" class="vs-select--label">시간(hhmm)-ex.0930</label>
                        <input
                            type="text"
                            class="w-full vs-inputx vs-input--input normal hasValue"
                            id="select_time"
                            name="select_time"
                            label="시간을 입력해주세요."
                            placeholder="시간을 입력해주세요."
                            maxlength="4"
                            v-model="select_time"
                        />
                    </div>
                </div>

                <vs-divider color="danger">DC</vs-divider>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/2 justify-between">
                        <span>
                            <vs-checkbox v-model="dc" style="width: 30%;">
                                DC
                            </vs-checkbox>
                        </span>
                    </div>
                    <div class="vx-col w-full lg:w-1/2 justify-between">
                        <span>
                            <vs-checkbox v-model="awaitTimeChk" @change="setAwaitTime" style="width: 30%;">
                                대기
                            </vs-checkbox>
                        </span>
                    </div>
                    <div class="vx-col w-full lg:w-1/1 justify-between">
                        <template v-if="dc == true">
                            <vs-input v-model="dc_memo" placeholder="취소사유" class="mt-1 w-full" />
                        </template>
                        <template >
                            <vs-input v-model="awaitTime" placeholder="시간" class="mt-1 w-full" v-show="this.userUid == '04059'"/>
                        </template>
                    </div>
                </div>

                <template v-if="viewManagerList.length > 0">
                    <vs-divider color="danger">치료자</vs-divider>
                    <div class="vx-row mb-3">
                        <div class="vx-col lg:w-1/1 justify-between" v-for="(item, index) in viewManagerList" :key="index">
                            <input type="radio" class="mr-2" :id="item.MEDICAL_MANAGER_NM" v-model="medicalManagers" :value="item.MEDICAL_MANAGER_CD" />
                            <label :for="item.MEDICAL_MANAGER_NM">
                                {{ item.MEDICAL_MANAGER_NM }}
                                <span v-if="item.VACATION_TYPE" class="text-danger">({{ item.VACATION_TYPE === 'FULL' ? '연차' : item.VACATION_TYPE === 'AM' ? '오전' : '오후' }})</span>
                            </label>
                        </div>
                    </div>
                </template>
                <template v-if="viewDetailList.length > 0">
                    <vs-divider color="danger">스케줄</vs-divider>
                    <div class="vx-row mb-3">
                        <div class="vx-col lg:w-1/1 justify-between" v-for="(item, index) in viewDetailList" :key="index">
                            <input type="checkbox" class="mr-2" :id="item.MEDICAL_DETAIL_NM" v-model="medicalDetails" :value="item.MEDICAL_DETAIL_CD" />
                            <label :for="item.MEDICAL_DETAIL_NM">{{ item.MEDICAL_DETAIL_NM }}</label>
                        </div>
                    </div>
                </template>
                <vs-divider color="danger">환자</vs-divider>
                <div class="vx-col w-full lg:w-1/1">
                    <v-select :maxHeight="'50px'" ref="searchInput" v-model="select_user" :closeOnSelect="true" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" @open="resetOption()"/>
                    <!-- <vs-input class="w-1/1" icon="search" placeholder="환자 이름 or 전화번호 or 차트번호 입력 후 엔터(Enter)" v-model="search" @keyup.enter="searchPatient()" /> -->
                </div>

                <vs-divider color="danger">메모</vs-divider>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1">
                        <textarea id="memo" class="vs-component vs-con-textarea vs-textarea-primary" style="border: 1px solid rgba(0, 0, 0, 0.08);padding:20px;"></textarea>
                    </div>
                </div>

                <div class="vx-row" style="margin-top:300px;">
                    <div class="vx-col w-full text-right">
                        <vs-button class="mr-3 mb-2" @click="calendarSave">저장</vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click="popupClose">닫기</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup>

        <vs-popup title="챠트보기" :active.sync="popupActive2">
            <div class="vx-row">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <vx-card class="p-2">
                        <div class="text-center">
                            <p class="text-grey">#{{ chart_no }}</p>
                            <h4>{{ patientUsername }}({{ status_name }})</h4>
                            <p class="text-grey">{{ patientAge }}, {{ patientGender }}</p>
                            <p class="text-grey">{{ patient_phone }}</p>
                        </div>
                        <vs-divider></vs-divider>
                        <!-- <vs-avatar class="mx-auto my-6 block" size="80px" /> -->
                        <div class="flex justify-between text-center">
                            <span>
                                <p class="font-semibold">{{ medicalRoomNm }}({{ medicalRoomNumberNm }})</p>
                                <small class="text-grey">병동(호실)</small>
                            </span>
                            <span>
                                <p class="font-semibold">{{ medicalName }}</p>
                                <small class="text-grey">본 병원</small>
                            </span>
                            <span>
                                <p class="font-semibold">{{ sickNess }}</p>
                                <small class="text-grey">병명</small>
                            </span>
                        </div>
                        <vs-divider></vs-divider>
                        <div class="my-6">
                            <h5 class="mb-2">치료플랜</h5>
                            <p class="plan_text">
                                <template v-if="plan == null || plan == 0">작성한 치료플랜 없음</template>
                                <template v-else>{{ plan }}</template>
                            </p>
                        </div>
                        <vs-divider></vs-divider>
                        <table style="width:100%;" class="border-collapse calendar">
                            <colgroup>
                                <col width="40%" />
                                <col width="60%" />
                            </colgroup>

                            <tbody>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">최초입원일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ in_init_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">입원일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ in_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">퇴원예정일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ out_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">왼퇴여부</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ complate_yn }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">식이</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ meal_name }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">보호자</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ protector_phone }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">주치의</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ medical_nm }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">협진의</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ west_medical_nm }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- <div class="my-6">
                            <h5 class="mb-2">컴플레인</h5>
                            {{ memo }}
                        </div> -->

                        <!-- <vs-button type="gradient" class="w-full mt-6" color="#7367F0" gradient-color-secondary="#CE9FFC" @click="patientMemoSave">저장</vs-button> -->
                    </vx-card>
                </div>
            </div>
        </vs-popup>

        <!-- 다중 복사 팝업 -->
        <vs-popup title="다중 복사" :active.sync="multiCopyPopup" class="multi-copy-popup">
            <div class="multi-copy-container">
                <div class="mb-4">
                    <h5>복사할 스케줄 선택</h5>
                    <div v-for="(item_data, index) in getSelectedSchedulesForMultiCopy()" :key="index" class="schedule-item mb-2 p-2 border rounded">
                        <input type="checkbox" v-model="multiCopyChecked" :value="item_data.SCHEDULE_SEQ" class="mr-2" />
                        <span>{{ item_data.REAL_TIME_STRING.substring(0, 2) }}:{{ item_data.REAL_TIME_STRING.substring(2, 4) }}</span>
                        <span class="ml-2">[{{ item_data.MEDICAL_NM ? item_data.MEDICAL_NM.substring(0, 1) : '' }}]</span>
                        <span class="ml-2">{{ item_data.MEDICAL_ROOM_NUMBER_NM }} {{ item_data.PATIENT_USERNAME }}</span>
                    </div>
                </div>
                
                <div class="mb-4">
                    <h5>복사할 날짜/시간 설정</h5>
                    <div class="target-dates-container">
                        <div v-for="(target, index) in targetDates" :key="index" class="target-date-item mb-2 p-2 border rounded">
                            <div class="flex items-center justify-between">
                                <div class="flex items-center">
                                    <datepicker 
                                        v-model="target.date" 
                                        :format="customFormatter"
                                        placeholder="날짜 선택"
                                        class="mr-2"
                                    />
                                    <input 
                                        type="text" 
                                        v-model="target.time" 
                                        placeholder="시간(HHMM)" 
                                        maxlength="4"
                                        class="vs-inputx vs-input--input time-input"
                                    />
                                </div>
                                <vs-button type="border" color="danger" size="small" @click="removeTargetDate(index)">삭제</vs-button>
                            </div>
                        </div>
                        <vs-button type="border" color="primary" size="small" @click="addTargetDate">날짜 추가</vs-button>
                    </div>
                </div>

                <div class="flex justify-end mt-4">
                    <vs-button class="mr-2" @click="executeMultiCopy">다중 복사</vs-button>
                    <vs-button color="warning" type="border" @click="closeMultiCopyModal">취소</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
import moment from 'moment';
import store from '@/store/store';
import DatePicker from 'vue2-datepicker';
import '../../assets/scss/vuexy/extraComponents/_datePicker.scss'
import VacationRow from '@/components/vacation/VacationRow.vue';
import DayFilterButtons from '@/components/common/DayFilterButtons.vue';
import vacationService from '@/services/vacationService';
import { managerFilterMixin } from '@/mixins/managerFilterMixin';
export default {
    mixins: [managerFilterMixin],
    components: {
        Datepicker,
      DatePicker,
        'v-select': vSelect,
        VacationRow,
        DayFilterButtons,
    },
    data() {
        return {
            now_date: '',
            prev_date: '',
            next_date: '',
            medical_cd: '',
            popupActive: false,
            time_index: -1,
            tab_menu: [],
            time_data: [],
            cure_data: [],
            cure_count: [],
            date_list: [],
            patient_member_list: [],
            time_list: [],
            // copyCheckedNew: [],
            select_medical_cd: {},
            select_date: '',
            select_time: '',
            select_user: null,
            options: [],
            now_day: '',
            active: false,
            copy_schedule_seq: -1,
            copy_select_date: '',
            copy_select_time: '',
            memo: '',
            popupActive2: false,
            patientUsername: '',
            patientUid: '',
            patientAge: '',
            patientGender: '',
            medicalRoomNm: '',
            medicalRoomNumberNm: '',
            medicalName: '',
            sickNess: '',
            plan: '',
            chart_no: '',
            status_name: '',
            patient_phone: '',
            in_init_date: '',
            in_date: '',
            out_date: '',
            complate_yn: '',
            meal_name: '',
            medical_nm: '',
            west_medical_nm: '',
            protector_phone: '',
            schedule_seq: -1,
            dc: false,
            dc_memo: '',
            copyChecked: [],
            start_date: '',
            end_date: '',
            tab_options: [],
            detailList: [],
            managerList: [],
            viewDetailList: [],
            viewManagerList: [],
            medicalDetails: [],
            medicalManagers: '',
            loginUid: '',
            tab_sum: 0,
            tab_all_tf: false,
            width: window.innerWidth,
            windowHeight: document.documentElement.clientHeight,
            awaitTime : '',
            awaitTimeChk : false,
            userUid : '',
            search : '',
            cardTitle : '외래치료실 스케쥴',
            vacationMap: new Map(),  // 연차 정보 캐시 - 2026-02-01

            // 다중 복사 관련 데이터
            multiCopyPopup: false,
            selectedScheduleForCopy: null,
            targetDates: [],
            multiCopyChecked: [],

            // 무한스크롤 페이지네이션 상태
            scrollOffset: 0,
            hasMoreTimeSlots: true,
            isLoadingMore: false,
            scrollObserver: null,
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
            this.windowHeight = document.documentElement.clientHeight;
        },

        async init(date) {
            this.now_day = dateClass.nowday();
            this.userUid = store.getters.getUID;
            if (date == '') {
                this.now_date = dateClass.dateYYYYMMDD();
            } else {
                this.now_date = date;
            }
            this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
            this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            // 무한스크롤 초기화
            this.scrollOffset = 0;
            this.hasMoreTimeSlots = true;
            this.isLoadingMore = false;
            this.teardownScrollObserver();

            let jsonData = {
                uid: this.loginUid,
                days: this.dayFilter,
                medical_cd: this.medical_cd,
                offset: 0,
                limit: this.scrollLimit,
            };
            const { data } = await axiosClass.get('/api/injection/list/' + this.now_date, jsonData, true);
            //console.log('data:::', data);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);
            // this.tab_menu = data.tab_menu;
            this.tab_menu = [];
            this.tab_sum = data.memberData.TAB_SUM_03;
            // console.log('this.tab_sum:::', this.tab_sum);
            for (let i = 0; i < data.tab_menu.length; i++) {
                this.tab_menu.push(data.tab_menu[i]);
            }
            this.tab_all_tf = this.tab_menu.length > 1;

            // console.log(this.tab_menu);
            for (let i = 0; i < this.tab_menu.length; i++) {
                this.tab_options.push({
                    id: this.tab_menu[i].MEDICAL_CD,
                    label: this.tab_menu[i].MEDICAL_NM,
                });
            }
            console.log('this.tab_menu:::', this.tab_menu);
            this.date_list = data.date_list;

            // 연차 정보 조회 - 2026-02-01
            await this.loadVacationInfo();

            this.cure_data = data.cure_data;
            this.hasMoreTimeSlots = data.has_more;
            this.scrollOffset = data.cure_data.length;
            this.cure_count = data.cure_count.map(c => {
              try {
                c.JSON_DATA = JSON.parse(c.JSON_DATA);
              } catch (e) {
                c.JSON_DATA = [];
              }
              return c;
            });

            this.start_date = this.date_list[0];
            this.end_date = this.date_list[this.date_list.length - 1];

            this.detailList = data.detailList;
            this.managerList = data.managerList;

            // 담당자 기반 기본 필터 설정 (첫 로드 시에만) - 2025-02-24
            if (!this.initialLoadDone) {
                const needsReload = this.applyDefaultFilterByManager();
                if (needsReload) {
                    // 담당자인 경우 해당 치료실 + 7일로 다시 로드
                    await this.tabClick(this.medical_cd);
                    return;
                }
            }

            // console.log('this.cure_data:::', this.cure_data);
            // console.log('this.detailList:::', this.detailList);
            // console.log('this.managerList:::', this.managerList);

            setTimeout(function() {
                // location.href = '#' + dateClass.dateYYYYMMDD();
                // location.href = '#' + dateClass.nowhour() + ':00';
                var element = document.getElementById(dateClass.dateYYYYMMDD());
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                }
            }, 500);

            this.$nextTick(() => {
                this.setupScrollObserver();
            });
        },
        async tabClick(medical_cd) {
            // 무한스크롤 초기화
            this.scrollOffset = 0;
            this.hasMoreTimeSlots = true;
            this.isLoadingMore = false;
            this.teardownScrollObserver();

            this.medical_cd = medical_cd;
            const params = {
                medical_cd: medical_cd,
                days: this.dayFilter,
                offset: 0,
                limit: this.scrollLimit,
            };
            // console.log(params);
            // console.log(this.now_date);
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            const { data } = await axiosClass.get('/api/injection/view/' + this.now_date, params, true);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.date_list = data.date_list;
            this.cure_data = data.cure_data;
            this.hasMoreTimeSlots = data.has_more;
            this.scrollOffset = data.cure_data.length;
            this.cure_count = data.cure_count.map(c => {
              try {
                c.JSON_DATA = JSON.parse(c.JSON_DATA);
              } catch (e) {
                c.JSON_DATA = [];
              }
              return c;
            });
            this.start_date = this.date_list[0];
            this.end_date = this.date_list[this.date_list.length - 1];

            // 담당자 목록 업데이트 추가 (연차 로드를 위해 필요) - 2026-02-24
            this.detailList = data.detailList;
            this.managerList = data.managerList;

            // 연차 정보 다시 로드 (선택된 치료실 담당자 기준) - 2026-02-24
            await this.loadVacationInfo();

            const baseTitle = '외래치료실 스케쥴';
            if (this.medical_cd === '') {
                document.title = baseTitle;
                this.cardTitle = baseTitle;
            } else {
                const selectedItem = this.tab_menu.find((item) => item.MEDICAL_CD === this.medical_cd);
                if (selectedItem && selectedItem.MEDICAL_NM) {
                    const newTitle = `${selectedItem.MEDICAL_NM} - ${baseTitle}`;
                    document.title = newTitle;
                    this.cardTitle = newTitle;
                } else {
                    document.title = baseTitle;
                    this.cardTitle = baseTitle;
                }
            }

            this.$nextTick(() => {
                this.setupScrollObserver();
            });
        },

        /**
         * Mixin에서 호출되는 데이터 리로드 함수
         * @description managerFilterMixin에서 changeDayFilter 시 호출됨
         */
        async reloadData() {
            await this.tabClick(this.medical_cd);
        },

        async loadMoreTimeSlots() {
            if (this.isLoadingMore || !this.hasMoreTimeSlots) return;
            this.isLoadingMore = true;
            try {
                const params = {
                    medical_cd: this.medical_cd,
                    days: this.dayFilter,
                    offset: this.scrollOffset,
                    limit: this.scrollLimit,
                };
                const { data } = await axiosClass.get('/api/injection/view/' + this.now_date, params, true);
                this.cure_data = this.cure_data.concat(data.cure_data);
                this.hasMoreTimeSlots = data.has_more;
                this.scrollOffset += data.cure_data.length;
            } catch (e) {
                console.error('[loadMoreTimeSlots] Error:', e);
            } finally {
                this.isLoadingMore = false;
            }
            // 데이터가 더 있지만 스크롤이 안 생기는 경우 observer 재설정으로 추가 로드
            if (this.hasMoreTimeSlots) {
                this.$nextTick(() => {
                    this.setupScrollObserver();
                });
            }
        },
        setupScrollObserver() {
            this.teardownScrollObserver();
            const scrollContainer = document.getElementById('calendarDiv');
            if (!scrollContainer) return;
            // IntersectionObserver가 이 구조(작은 root + 중첩 테이블)에서 트리거되지 않아
            // scroll 이벤트 기반 하단 근접 감지로 교체 (2026-07-02, 실측 검증)
            this._scrollHandler = () => {
                if (!this.hasMoreTimeSlots || this.isLoadingMore) return;
                if (scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 200) {
                    this.loadMoreTimeSlots();
                }
            };
            scrollContainer.addEventListener('scroll', this._scrollHandler, { passive: true });
            // 초기 콘텐츠가 컨테이너를 못 채워 스크롤이 불가능하면 자동으로 다음 페이지 로드
            this.$nextTick(() => {
                if (this.hasMoreTimeSlots && !this.isLoadingMore &&
                    scrollContainer.scrollHeight <= scrollContainer.clientHeight + 200) {
                    this.loadMoreTimeSlots();
                }
            });
        },
        teardownScrollObserver() {
            if (this.scrollObserver) {
                this.scrollObserver.disconnect();
                this.scrollObserver = null;
            }
            if (this._scrollHandler) {
                const sc = document.getElementById('calendarDiv');
                if (sc) sc.removeEventListener('scroll', this._scrollHandler);
                this._scrollHandler = null;
            }
        },

        async calendarSave() {
            let errorMsg = '';
            if (this.select_date == '--') {
                this.select_date = '';
            }

            if (this.select_medical_cd == '') {
                errorMsg = '치료실을 선택하여 주십시오.';
            } else if (this.medicalManagers.length > 0) {
                if (this.medicalManagers == '') {
                    errorMsg = '치료자를 선택하여 주십시오.';
                }
            } else if (this.select_date == '') {
                errorMsg = '날짜를 선택해주세요.';
            } else if (this.select_time == '') {
                errorMsg = '시간을 입력해주세요.';
            }

            // else if (this.medicalDetails.length > 0) {
            //     if (this.medicalDetails == '') {
            //         errorMsg = '스케줄을 선택하여 주십시오.';
            //     }
            // }

            if (this.select_user.length == 0) {
                errorMsg = '환자를 선택하여 주십시오.';
            }

            if (errorMsg != '') {
                this.$vs.notify({
                    title: 'Error',
                    text: errorMsg,
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }

            const memo = document.getElementById('memo').value;
            let select_time = document.getElementById('select_time').value;

            if (isNaN(select_time) == false) {
                this.select_time = select_time;
            }

            let dcString = '';
            if (this.dc == false) {
                dcString = 'N';
            } else {
                dcString = 'Y';
            }

            const jsonData = {
                select_medical_cd: this.select_medical_cd,
                select_date: this.select_date,
                select_time: this.select_time,
                select_user: JSON.stringify(this.select_user),
                tab_medical_cd: this.medical_cd,
                schedule_seq: this.schedule_seq,
                memo: memo,
                dc: dcString,
                dc_memo: this.dc_memo,
                medicalDetails: this.medicalDetails.join(),
                medicalManagers: this.medicalManagers,
                awaitTime : this.awaitTime + '',
                days: this.dayFilter
            };

            //console.log('check:' + jsonData);
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            const { data } = await axiosClass.post('/api/injection/save', jsonData, true);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.popupActive = false;
            this.initPopupData();

            this.date_list = data.date_list;
            this.cure_data = data.cure_data;
            this.cure_count = data.cure_count.map(c => {
              try {
                c.JSON_DATA = JSON.parse(c.JSON_DATA);
              } catch (e) {
                c.JSON_DATA = [];
              }
              return c;
            });

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
        },
        async memberView(uid) {
            this.$EventBus.$emit('memberView', uid);
        },

        async clipCopy(item) {
            // console.log(document.getElementById(item.schedule_seq).getElementsByClassName('con-vs-chip')[0].style);
            const div = document.getElementsByClassName('con-vs-chip');
            for (let i = 0; i < div.length; i++) {
                div[i].classList.remove('selectOn');
            }

            this.copy_schedule_seq = -1;
            if (
                document
                    .getElementById(item.schedule_seq)
                    .getElementsByClassName('con-vs-chip')[0]
                    .classList.contains('selectOn')
            ) {
                document
                    .getElementById(item.schedule_seq)
                    .getElementsByClassName('con-vs-chip')[0]
                    .classList.remove('selectOn');
            } else {
                document
                    .getElementById(item.schedule_seq)
                    .getElementsByClassName('con-vs-chip')[0]
                    .classList.add('selectOn');
            }

            this.copy_schedule_seq = item.schedule_seq;
        },

        async clipCopyConfirm(ymd, time) {
            // console.log(this.copy_schedule_seq + '///' + ymd + '///' + time);
            this.copy_select_date = ymd;
            this.copy_select_time = time;

            if (this.copyChecked.length == 0) {
                this.$vs.notify({
                    title: '확인',
                    text: '복사할 컨텐츠를 선택해주세요.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }

            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '선택한 예약을 복사하시겠습니까?',
                acceptText: '복사',
                cancelText: '취소',
                accept: this.DataCopy,
                cancel: function() {
                    return;
                },
            });
            // document.getElementsByClassName('con-vs-chip').classList.remove('selectOn');
        },

        async DataCopy() {
            const jsonData = {
                copy_date: this.copyChecked,
                ymd: this.copy_select_date,
                time: this.copy_select_time,
                medical_cd: this.medical_cd,
                days: this.dayFilter,
            };

            const { data } = await axiosClass.post('/api/injection/copyV2', jsonData, true);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.popupActive = false;
            this.initPopupData();

            this.date_list = data.date_list;
            this.cure_data = data.cure_data;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });

            const div = document.getElementsByClassName('con-vs-chip');
            for (let i = 0; i < div.length; i++) {
                div[i].classList.remove('selectOn');
            }
            this.copy_schedule_seq = -1;
        },

        async popupmodify(item) {
            // console.log(item);
            this.schedule_seq = item.SCHEDULE_SEQ;
            this.popupActive = true;
            const { data } = await axiosClass.get('/api/cure/schedule/' + item.SCHEDULE_SEQ, {}, true);
            // console.log('popupmodify:::data:::', data);
            this.time_list = data.timeList;

            this.options = [];
            // this.select_medical_cd = this.medical_cd;
            this.select_user = null;
            for (let i = 0; i < data.memberList.length; i++) {
                this.options.push({
                    id: data.memberList[i].PATIENT_UID,
                    label: data.memberList[i].MEDICAL_ROOM_NM + '-' + data.memberList[i].MEDICAL_ROOM_NUMBER_NM + ':' + data.memberList[i].PATIENT_USERNAME,
                });

                if (data.memberList[i].PATIENT_UID == data.selectData.PATIENT_UID) {
                    this.select_user = this.options[i];
                }
            }

            // this.select_medical_cd = data.selectData.MEDICAL_CODE;
            for (let i = 0; i < this.tab_options.length; i++) {
                if (this.tab_options[i].id == data.selectData.MEDICAL_CODE) {
                    this.select_medical_cd = this.tab_options[i];
                }
            }

            this.select_date = data.selectData.YMD_STRING.substring(0, 4) + '-' + data.selectData.YMD_STRING.substring(4, 6) + '-' + data.selectData.YMD_STRING.substring(6, 8);
            this.select_time = data.selectData.REAL_TIME_STRING;
            document.getElementById('memo').value = data.selectData.MEMO;

            if (data.selectData.DC == 'Y') {
                this.dc = true;
            } else {
                this.dc = false;
            }

            this.dc_memo = data.selectData.DC_MEMO;
            this.select_medical_input();
            this.awaitTimeChk = data.selectData.AWAIT_TIME == '' ? false : true;
            this.awaitTime = data.selectData.AWAIT_TIME;

            if (data.selectData.MEDICAL_DETAILS != '') this.medicalDetails = data.selectData.MEDICAL_DETAILS.split(',');
            if (data.selectData.MEDICAL_MANAGERS != '') this.medicalManagers = data.selectData.MEDICAL_MANAGERS;

            this.popupActive = true;
        },

        async calendarTdClick(item, schedule_item) {
            // console.log(this.medical_cd);
            this.select_time = item.CODE_TIME;
            this.select_date = this.customFormatter(schedule_item);
            // this.select_medical_cd = this.medical_cd;
            this.select_user = null;
            await this.popupOpen();
        },
        async calendarTdDelete(item) {
            // console.log(item);
            this.select_schedule_seq = item.SCHEDULE_SEQ;
            this.popupActive = false;
            let _this = this;
            _this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '예약된 외래치료실(' + item.MEDICAL_ROOM_NUMBER_NM + '-' + item.PATIENT_USERNAME + ')를 정말로 삭제하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: _this.calendarDelete,
            });
        },

        async calendarDelete() {
            if (this.now_date == '') {
                this.now_date = dateClass.dateYYYYMM();
            }
            const jsonData = {
                select_date: this.now_date,
                tab_medical_cd: this.medical_cd,
                days: this.dayFilter,
            };

            const { data } = await axiosClass.delete('/api/injection/deleteV2/' + this.select_schedule_seq, jsonData, true);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            // console.log(data);

            this.popupActive = false;

            this.date_list = data.date_list;
            this.cure_data = data.cure_data;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 삭제되었습니다.',
                color: 'danger',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
        },
        getCureCountForDay(dayYmd) {
            const countData = this.cure_count.find(c => c.YMD === dayYmd);
            return countData ? countData.JSON_DATA : [];
        },
        async curePlan(schedule_seq) {
            // console.log(schedule_seq);
            const { data } = await axiosClass.post('/api/cure/select/' + schedule_seq, {}, true);
            // console.log(data.cure_plan['PATIENT_USERNAME']);
            if (data.cure_plan['PLAN'] == '') {
                data.cure_plan['PLAN'] = '없음';
            }
            this.popupActive = false;
            let _this = this;
            _this.$vs.dialog({
                color: 'primary',
                title: data.cure_plan['PATIENT_USERNAME'] + '님 치료플랜',
                text: data.cure_plan['PLAN'],
                acceptText: '닫기',
            });
        },
        initPopupData() {
            this.schedule_seq = -1;
            this.dc = false;
            this.dc_memo = '';
            if (document.getElementById('memo')) {
                document.getElementById('memo').value = '';
            }
            this.select_date = '';
            this.select_time = '';
            this.awaitTimeChk = false;
            this.awaitTime = '';
            this.select_user = null;
            this.select_medical_cd = {};
            this.medicalDetails = [];
            this.medicalManagers = '';
            this.viewDetailList = [];
            this.viewManagerList = [];
            this.options = [];
        },
        async popupOpen(day, time) {
            this.initPopupData();
            if (day) {
                this.select_date = day.substring(0, 4) + '-' + day.substring(4, 6) + '-' + day.substring(6, 8);
            }
            this.select_time = time;
            const { data } = await axiosClass.get('/api/injection/select', {}, true);
            // console.log('popupOpen:::data:::', data);
            this.time_list = data.timeList;

            for (let i = 0; i < this.tab_options.length; i++) {
                if (this.tab_options[i].id == this.medical_cd) {
                    this.select_medical_cd = this.tab_options[i];
                }
            }
            this.select_medical_input();

            this.popupActive = true;
        },
        select_medical_input() {
            this.viewDetailList = [];

            for (let i = 0; i < this.detailList.length; i++) {
                if (this.detailList[i].MEDICAL_CD == this.select_medical_cd.id) {
                    this.viewDetailList.push(this.detailList[i]);
                }
            }

            this.viewManagerList = [];
            for (let i = 0; i < this.managerList.length; i++) {
                if (this.managerList[i].MEDICAL_CD == this.select_medical_cd.id) {
                    this.viewManagerList.push(this.managerList[i]);
                }
            }
            this.medicalDetails = [];
            // 첫 번째 치료자를 기본 선택
            this.medicalManagers = this.viewManagerList.length > 0 ? this.viewManagerList[0].MEDICAL_MANAGER_CD : '';
            // console.log('this.detailValue:::', this.medicalDetails);
        },
        async memberReport(uid) {
            const { data } = await axiosClass.get('/api/remote/userData/' + uid, {}, true);
            // console.log(uid);
            // console.log(data);
            this.popupActive2 = true;
            this.patientUsername = data.patientData.PATIENT_USERNAME;
            this.patientAge = data.patientData.PATIENT_AGE;
            this.patientGender = data.patientData.PATIENT_GENDER_CONVERT;
            this.medicalRoomNm = data.patientData.MEDICAL_ROOM_NM;
            this.medicalRoomNumberNm = data.patientData.MEDICAL_ROOM_NUMBER_NM;
            this.medicalName = data.patientData.MEDICAL_NAME;
            this.sickNess = data.patientData.SICKNESS;
            this.plan = data.patientData.PLAN;
            this.memo = data.patientData.MEMO;
            this.chart_no = data.patientData.CHART_NO;
            this.status_name = data.patientData.STATUS_NAME;
            this.patient_phone = data.patientData.PATIENT_PHONE;
            this.in_init_date = data.patientData.IN_INIT_DATE;
            this.in_date = data.patientData.IN_DATE;
            this.out_date = data.patientData.OUT_DATE;
            this.complate_yn = data.patientData.COMPLATE_YN;
            this.meal_name = data.patientData.MEAL_NAME;
            this.medical_nm = data.patientData.MEDICAL_NM;
            this.west_medical_nm = data.patientData.WEST_MEDICAL_NAME;
            this.protector_phone = data.patientData.PROTECTOR_PHONE;
            // console.log(data);
        },
        popupClose() {
            this.popupActive = false;
            this.initPopupData();
        },

        dayReturn(item) {
            const week = ['일', '월', '화', '수', '목', '금', '토'];
            const weekString = week[new Date(item.substring(0, 4) + '-' + item.substring(4, 6) + '-' + item.substring(6, 8)).getDay()];
            return parseInt(item.substring(4, 6)) + '월 / ' + parseInt(item.substring(6, 8)) + '일(' + weekString + ')';
        },

        getBtnColor(schedule) {
            let btn_color = '';
             if (schedule.MEDICAL_NM.trim() == '면역주사실') {
                btn_color = 'background-color:rgba(128,175,178, 0.3);';
            } else if (schedule.MEDICAL_NM.trim() == '외래고주파') {
                btn_color = 'background-color:rgba(150,180,214, 0.3);';
            } else if (schedule.MEDICAL_NM.trim() == '한&양방 진료상담') {
                btn_color = 'background-color:rgba(196,164,148, 0.3);';
            } else if (schedule.MEDICAL_NM.trim() == '외래 한방치료') {
                btn_color = 'background-color:rgba(201,149,164, 0.3);';
            } else if (schedule.MEDICAL_NM.trim() == '임상병리실') {
                btn_color = 'background-color:rgba(179,167,206, 0.3);';
            } else {
                btn_color = 'background-color:rgba(185,232,239,0.3);';
            }

            if (schedule.AWAIT_TIME && schedule.AWAIT_TIME.trim() != '') {
                btn_color = 'background-color:rgba(102, 101, 101,0.3);';
            }
            return btn_color;
        },
        getDetailNames(schedule) {
            if (!schedule.MEDICAL_DETAILS) return '';
            const detail_codes = schedule.MEDICAL_DETAILS.split(',');
            let detailNm = '';
            
            detail_codes.forEach((code, index) => {
                const trimmedCode = code.trim();
                const detailInfo = this.detailList.find(d => d.MEDICAL_DETAIL_CD == trimmedCode && d.MEDICAL_CD == schedule.MEDICAL_CODE);
                if (detailInfo) {
                    detailNm += (index > 0 ? ', ' : '') + detailInfo.MEDICAL_DETAIL_NM;
                }
            });
            return detailNm;
        },
        // 연차 정보 조회 - 2026-02-01 (리팩토링: vacationService 사용)
        async loadVacationInfo() {
            try {
                if (!this.date_list || this.date_list.length === 0) return;

                // 현재 선택된 치료실 담당자 또는 전체 담당자 UID 추출
                let managerUids = [];

                if (this.medical_cd) {
                    // 특정 치료실 선택 시 해당 치료실 담당자만
                    managerUids = this.managerList
                        .filter(m => m.MEDICAL_CD === this.medical_cd)
                        .map(m => m.MEDICAL_MANAGER_CD);
                } else {
                    // 전체 선택 시 모든 담당자
                    managerUids = this.managerList.map(m => m.MEDICAL_MANAGER_CD);
                }

                if (managerUids.length === 0) {
                    this.vacationMap = new Map();
                    return;
                }

                const startDate = this.date_list[0].substring(0, 4) + '-' + this.date_list[0].substring(4, 6) + '-' + this.date_list[0].substring(6, 8);
                const endDate = this.date_list[this.date_list.length - 1].substring(0, 4) + '-' + this.date_list[this.date_list.length - 1].substring(4, 6) + '-' + this.date_list[this.date_list.length - 1].substring(6, 8);

                // vacationService 사용
                this.vacationMap = await vacationService.getVacationsByManagers(
                    startDate,
                    endDate,
                    managerUids
                );
            } catch (error) {
                console.error('연차 정보 조회 실패:', error);
                this.vacationMap = new Map();
            }
        },

        /**
         * VacationRow용 날짜 키 포맷 함수
         */
        formatDateKeyForVacation(dateString) {
            if (typeof dateString === 'string') {
                return dateString.replace(/-/g, '');
            }
            return '';
        },
        /**
         * 담당자 이름 표시 (연차 정보 없이 - 카드용)
         */
        getManagerNamesSimple(schedule) {
            if (!schedule.MEDICAL_MANAGERS) return '';
            const manager_codes = schedule.MEDICAL_MANAGERS.split(',');
            let managerNm = '';
            manager_codes.forEach((code, index) => {
                const trimmedCode = code.trim();
                const managerInfo = this.managerList.find(m => m.MEDICAL_MANAGER_CD == trimmedCode);
                if (managerInfo) {
                    const name = managerInfo.MEDICAL_MANAGER_NM.substr(0, 1);
                    managerNm += (index > 0 ? ', ' : '') + name;
                }
            });
            return managerNm;
        },
        prevMonth() {
            this.now_date = this.prev_date;
            this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
            this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
            this.tabClick(this.medical_cd);
        },
        nextMonth() {
            this.now_date = this.next_date;
            this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
            this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
            this.tabClick(this.medical_cd);
        },
      updateDate(day) {
        if (day) {
          this.now_date = day;
          this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
          this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
          this.tabClick(this.medical_cd);
        }
      },
        activeMenu(medical_code) {
            if (medical_code == this.medical_cd) {
                return 'activeMenu';
            } else {
                return '';
            }
        },

        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        setAwaitTime() {
            if(this.awaitTimeChk == true) {
                this.awaitTime = moment().format('YYYY-MM-DD HH:mm:ss');
            } else {
                this.awaitTime = '';
            }
            
        },
        async searchPatient (value) {
            this.options = [];

            let params = {
                search_name : value
            }

            if(value != ''){
                const { data } = await axiosClass.get(
                    "/api/patient/search_patientList",
                    params,
                    true
                );
                for (let i = 0; i < data.data.length; i++) {
                    this.options.push({
                        id: data.data[i].PATIENT_UID,
                        patientPhone : data.data[i].PATIENT_PHONE,
                        patientName : data.data[i].PATIENT_USERNAME,
                        patientUid : data.data[i].PATIENT_UID,
                        oxygenPoint : data.data[i].OXYGEN_POINT || 0,
                        label: (data.data[i].MEDICAL_ROOM_NM != '' ? data.data[i].MEDICAL_ROOM_NM + '-' + data.data[i].MEDICAL_ROOM_NUMBER_NM + ' : ' : '') + data.data[i].CHART_NO + '/' + data.data[i].PATIENT_USERNAME + '('+ data.data[i].PATIENT_PHONE.substr(9,4) + ')',
                    });
                }
            }

        },
        resetOption () {
            this.options=[];
        },

        // 다중 복사 관련 새로운 메서드들
        openMultiCopyModal(ymd, time) {
            this.selectedScheduleForCopy = {
                ymd: ymd,
                time: time
            };
            this.multiCopyChecked = [];
            this.targetDates = [{ date: '', time: '' }];
            this.multiCopyPopup = true;
        },

        getSelectedSchedulesForMultiCopy() {
            if (!this.selectedScheduleForCopy) return [];
            
            const ymd = this.selectedScheduleForCopy.ymd;
            const time = this.selectedScheduleForCopy.time;
            
            // 해당 시간대의 모든 스케줄을 찾아서 반환
            for (let i = 0; i < this.cure_data.length; i++) {
                if (this.cure_data[i].CODE_TIME === time) {
                    return this.gridReturn(i, this.date_list.findIndex(d => d === ymd));
                }
            }
            return [];
        },

        addTargetDate() {
            this.targetDates.push({ date: '', time: '' });
        },

        removeTargetDate(index) {
            this.targetDates.splice(index, 1);
        },

        closeMultiCopyModal() {
            this.multiCopyPopup = false;
            this.selectedScheduleForCopy = null;
            this.multiCopyChecked = [];
            this.targetDates = [];
        },

        async executeMultiCopy() {
            if (this.multiCopyChecked.length === 0) {
                this.$vs.notify({
                    title: '확인',
                    text: '복사할 스케줄을 선택해주세요.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }

            if (this.targetDates.length === 0 || this.targetDates.some(t => !t.date || !t.time)) {
                this.$vs.notify({
                    title: '확인',
                    text: '복사할 날짜와 시간을 모두 입력해주세요.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }

            this.$vs.dialog({
                type: 'confirm',
                color: 'primary',
                title: '다중 복사',
                text: `선택한 스케줄을 ${this.targetDates.length}개 날짜/시간으로 복사하시겠습니까?`,
                acceptText: '복사',
                cancelText: '취소',
                accept: () => {
                    this.executeMultiDataCopy();
                }
            });
        },

        async executeMultiDataCopy() {
            const targetDatesFormatted = this.targetDates.map(target => {
                // Date 객체인 경우 문자열로 변환
                let dateString = target.date;
                if (target.date instanceof Date) {
                    dateString = this.customFormatter(target.date);
                }
                return {
                    date: dateString.replace(/-/g, ''),
                    time: target.time
                };
            });

            const jsonData = {
                source_schedule_seqs: this.multiCopyChecked,
                target_dates_times: targetDatesFormatted,
                medical_cd: this.medical_cd,
                send_sms: true,
                days: this.dayFilter,
            };

            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });

            try {
                const { data } = await axiosClass.post('/api/injection/multiCopyV2', jsonData, true);
                
                setTimeout(() => {
                    this.$vs.loading.close('#schedule > .con-vs-loading');
                }, 100);

                this.closeMultiCopyModal();
                
                // 데이터 새로고침
                this.date_list = data.cure_data[0].YMD.split(',');
                this.cure_data = data.cure_data;
                this.cure_count = data.cure_count;

                this.$vs.notify({
                    title: 'Success',
                    text: '다중 복사가 완료되었습니다.',
                    color: 'success',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
            } catch (error) {
                setTimeout(() => {
                    this.$vs.loading.close('#schedule > .con-vs-loading');
                }, 100);

                this.$vs.notify({
                    title: 'Error',
                    text: '다중 복사 중 오류가 발생했습니다.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-x',
                });
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.loginUid = store.getters.getUID;
        document.title = this.$route.meta.title || '메디람한방병원';
        this.init('');
        this.$nextTick(() => {
            const inputElement = this.$refs.searchInput.$el.querySelector("input");
            if (inputElement) {
            inputElement.addEventListener("keyup", (event) => {
                if (event.key === "Enter") {
                    
                this.searchPatient(inputElement.value);
                }
            });
            }
        });
    },

    computed: {
        scrollLimit() {
            const availableHeight = this.windowHeight - 500;
            const rowHeight = 120; // 100px row + padding/border
            return Math.max(3, Math.floor(availableHeight / rowHeight));
        },
        nowDate() {
            return this.now_date.substring(0, 4) + '년 ' + this.now_date.substring(4, 6) + '월';
        },
    },
    beforeDestroy() {
        this.teardownScrollObserver();
        window.removeEventListener('resize', this.handleResize);
    },
};

window.addEventListener('resize', reportWindowSize);
window.addEventListener('load', reportWindowSize);
function reportWindowSize() {
    document.getElementById('calendarDiv').style.height = document.documentElement.clientHeight - 500 + 'px';
}
</script>

<style>
.calendar tbody tr td {
    padding: 10px;
}

.includeIcon {
    display: initial;
}

.con-vs-chip {
    min-height: 40px;
}

.vs-chip--text {
    font-size: 0.9rem;
}

.activeMenu {
    border-color: #015666;
}

.display-time {
    padding: 0.7rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
}
table > thead > tr > th {
    font-weight: 400;
    background-color: blue;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    z-index: 1;
}
table > tbody > tr > td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.tb_box {
    overflow: auto;
}
.table_header {
    position: sticky;
    top: 0;
}

.selectOn {
    border: 3px solid #439798;
    color: #fff;
}

.selectOff {
    border: 0px;
    color: #fff;
}
.contentTable {
    font-size: 12px;
}
.headerBtn {
    background-color: rgba(241, 241, 241, 0.9);
    padding: 5px 10px;
}
.headerBtn a {
    padding: 5px;
}

.timeHeader {
    position: sticky;
    left: 0;
    top: auto; /* table_header의 top:0 세로 sticky 무효화 - 시간 라벨 겹침 방지 (2026-07-02) */
    z-index: 999;
}

/* 다중 복사 팝업 스타일 */
.multi-copy-popup .con-vs-popup {
    max-width: 600px;
    min-height: 400px;
}

.multi-copy-container {
    padding: 20px;
}

.schedule-item {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}

.target-date-item {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}

.time-input {
    width: 100px;
    text-align: center;
}

.target-dates-container {
    max-height: 300px;
    overflow-y: auto;
}

/* .tb_box::-webkit-scrollbar {
  display: none;
} */
</style>
